export const convertPriceData = (prices) => {
    return {
        currencyToDisplay: prices.subtotalIncludingTax.currency,
        subtotalToDisplay: prices.subtotalIncludingTax.value,
        depositToDisplay: 0,
        shippingToDisplay: prices.shipping?.value ?? 0,
        totalToDisplay: prices.grandTotal.value,
        totalNowTaxToDisplay: prices.appliedTaxes,
    };
};
//# sourceMappingURL=convertPriceData.js.map